module.exports = __webpack_public_path__ + "img/登录背景.6508ff7c.jpg";